import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import Tappable from 'react-tappable/lib/Tappable';

import {
  fetchPreviousOnlineConsultation,
  getAllRelatives,
  fetchConsultationBlocker,
  getConsultationSummary,
  getAllDopeRelatives,
} from '../../services/consultation';
import clientConfig from '../../clientConfig';
import { logEvent } from '../../utils/logEvent';
import FAB from '../../components/common/FAB';
import { resetChat, setCurrentActiveTab } from '../../actions';
import { Text, ButtonText } from '../../components/common/Text';
import { PrimaryButton } from '../../components/common/Buttons';
import { FadeInTransition } from '../../components/transitions/transitions';
import RelativeSelect from '../../components/consultations/RelativeSelect';
import NewOnlineConsultationCard from '../../components/consultations/new-flow/ConsultationOrderCard';
import LoadingSkeleton from '../../components/common/Skeleton/ConsultationStartPreview';

import cartIcon from '../../images/consultations/new-flow/cart-icon.svg';
import onlineDoctorLottie from '../../images/consultations/online-doctor.json';
import Header from '../../components/common/Header';
import dismissNativeWebViewOrNavigateHome from '../../utils/dismissNativeWebViewOrNavigateHome';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #f8f8f8;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  padding: 16px;
  z-index: 10;
  border-bottom: 1px solid #e2e3ea;
`;

const BackContainer = styled(Tappable)`
  margin-right: 3px;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const HeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: stretch;
  overflow: auto;
  // -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 16px;
  background: white;
  position: relative;
`;
const CTA = styled(PrimaryButton)`
  justify-content: space-between;
`;
class OnlineConsultationStartPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verticals: [],
      showVerticalsLeftScroll: false,
      showVerticalsRightScroll: true,
      ongoingAppointment: [],
      completedAppointment: [],
      cancelledAppointment: [],
      scheduledAppointment: [],
      cards: [],
      loading: true,
      relatives: [],
      selectedRelative: null,
      showRelativeModal: false,
      blockers: {},
      from: 'home',
      isScheduledConsult: false,
    };
    this.verticalScrollContainerRef = React.createRef();
    const { state } = this.props.location;
    if (state && state.openConsultId) {
      this.state.openConsultId = parseInt(state.openConsultId);

      if (state.isScheduledConsult) {
        this.state.isScheduledConsult = true;
      } else {
        this.state.isScheduledConsult = true;
      }
    }
    if (state && state.from === 'home') {
      props.dispatch(setCurrentActiveTab('home'));
    } else {
      props.dispatch(setCurrentActiveTab('online-orders'));
    }
  }

  componentDidMount() {
    // GA tracking
    window.gtag('event', 'screen_view', {
      screen_name: 'Consult Screen',
    });
    this.props.dispatch(resetChat());
    logEvent('Online Consultations Home Screen');
    this.setState({
      loading: true,
    });
    this.getAllRelatives();
    this.fetchConsultationBlocker();
    this.getConsults('all');
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.location.hash === '#profile' &&
      this.props.location.hash !== '#profile'
    ) {
      this.closeProfile();
      return;
    }

    if (
      prevState.selectedRelative &&
      !this.state.selectedRelative &&
      this.state.selectedRelative !== prevState.selectedRelative
    ) {
      this.getConsults('all');
    }
    if (
      this.state.selectedRelative &&
      this.state.selectedRelative !== prevState.selectedRelative &&
      !this.state.loading
    ) {
      this.getConsults();
    }
  }

  openOrder(order) {
    this.props.dispatch(resetChat());
    const { consultationId } = order;
    const { history, authToken, userId } = this.props;
    this.setState({
      openConsultId: null,
    });
    if (order.type === 'reimbursement') {
      history.push('/consultation/reimbursement-details', {
        reimbursementId: order.reimbursementId,
        goBack: true,
      });
    } else if (order.isScheduledConsult) {
      history.push('/consultation/online/appointment-status', {
        scheduledConsultationId: consultationId,
      });
    } else {
      getConsultationSummary(consultationId, userId, authToken)
        .then((res) => {
          const { consultationInfo } = res;
          history.push('/consultation/chat', {
            consultationId: consultationInfo.consultationId,
            channel: consultationInfo.chatChannel,
            doctorName: consultationInfo.doctorName,
            doctorVertical: consultationInfo.doctorDegrees,
            doctorId: consultationInfo.doctorId,
            pendingRequest: consultationInfo.isOver === false,
            requestId: consultationInfo.requestId,
            profileImg: consultationInfo.doctorImg,
            isFreeConsult: consultationInfo.freeConsult,
            activeContact: res.activeContact,
            userSkippedEmergencyContact: res.userSkippedEmergencyContact,
            isOver: consultationInfo.isOver,
          });
        })
        .catch((err) => {
          console.error('Error in fetching consultation info ', err);
        });
    }
  }

  onNext = () => {
    const { history } = this.props;
    const { selectedRelative, selectedIssues, selectedIssuesIndex } =
      this.state;
    if (this.searchType === 'treat') {
      history.push('/consultation/request-summary', {
        relative: selectedRelative,
        selectedIssues,
        selectedIssuesIndex,
      });
    } else {
      // Specialist search. Take directly to search screen
      history.push('/consultation/specialist-search', {
        issueIds: selectedIssuesIndex,
        onlineFilters: this.filters.ONLINE,
        offlineFilters: this.filters.OFFLINE,
        showOnlineAndOffline: true,
        consultRequestInfo: {
          selectedIssuesIndex,
          relative: selectedRelative,
        },
      });
    }
  };

  onVerticalListScrolled = (event) => {
    const { showVerticalsLeftScroll, showVerticalsRightScroll } = this.state;
    if (event.target.scrollLeft > 0) {
      !showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: true,
        });
    } else {
      showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: false,
        });
    }
    if (
      event.target.scrollLeft + event.target.clientWidth <
      event.target.scrollWidth
    ) {
      !showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: true });
    } else {
      showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: false });
    }
  };

  smoothScroll(ele, left, reverse) {
    const start = performance.now();
    const duration = 300;
    const startValue = ele.scrollLeft;
    const scrollPerTimestamp = Math.abs(left - startValue) / duration;
    const multiplier = reverse ? 1 : -1;
    const animate = (timestamp) => {
      const progress = timestamp - start;
      ele.scrollTo(startValue + multiplier * scrollPerTimestamp * progress, 0);
      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }

  scrollVerticalsLeft = () => {
    const { scrollLeft, clientWidth } = this.verticalScrollContainerRef.current;
    if (scrollLeft === 0) {
      return;
    }
    if (scrollLeft < clientWidth / 2) {
      this.smoothScroll(this.verticalScrollContainerRef.current, 0);
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft - clientWidth / 2
    );
  };

  scrollVerticalsRight = () => {
    const { scrollLeft, clientWidth, scrollWidth } =
      this.verticalScrollContainerRef.current;
    if (scrollLeft + clientWidth >= scrollWidth) {
      return;
    }
    if (scrollWidth - scrollLeft + clientWidth < clientWidth / 2) {
      this.smoothScroll(
        this.verticalScrollContainerRef.current,
        scrollWidth - clientWidth,
        true
      );
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft + clientWidth / 2,
      true
    );
  };

  getAllRelatives = () => {
    const { authToken, user } = this.props;
    const fetchFn = clientConfig.useDopeRelatives
      ? getAllDopeRelatives
      : getAllRelatives;
    fetchFn(authToken)
      .then((res) => {
        const self = {
          age: user.userAge,
          dob: user.dateOfBirth,
          gender: user.userGender,
          id: 'self',
          name: user.userName,
          phone: user.userPhone,
          relation: user.userType,
        };
        const relatives = [self, ...res.relatives];
        this.setState({
          relatives,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getConsults(id = null) {
    const { authToken } = this.props;

    if (!id) {
      id =
        this.state.selectedRelative && this.state.selectedRelative.id
          ? this.state.selectedRelative.id
          : 'all';
    }
    fetchPreviousOnlineConsultation(id, authToken)
      .then((res) => {
        const cards = res.cards;

        let ongoingAppointment = [];
        let completedAppointment = [];
        let cancelledAppointment = [];
        let scheduledAppointment = [];

        for (let i = 0; i < res.consultations.length; i++) {
          const consultation = res.consultations[i];
          if (consultation.cancelled) {
            cancelledAppointment.push(consultation);
          } else if (consultation.isScheduledConsult) {
            scheduledAppointment.push(consultation);
          } else {
            // For prod these will not come
            if (consultation.daysRemaining === 0) {
              completedAppointment.push(consultation);
            } else {
              ongoingAppointment.push(consultation);
            }
          }
        }

        if (this.state.openConsultId && res.consultations.length > 0) {
          const orderToOpen = res.consultations.filter((ele) => {
            return ele.consultationId === this.state.openConsultId;
          });

          if (orderToOpen.length === 1) {
            this.openOrder(orderToOpen[0]);
          }
        }

        if (res.consultations.length === 0 && this.state.selectedRelative) {
          this.setState({ selectedRelative: null });
        }
        this.setState(
          {
            completedAppointment,
            ongoingAppointment,
            cancelledAppointment,
            scheduledAppointment,
            cards,
          },
          () => {
            this.setState({ loading: false });
          }
        );
      })
      .catch((err) => {
        console.error('Error fetching previous online consultations', err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  fetchConsultationBlocker = () => {
    fetchConsultationBlocker(this.props.authToken)
      .then((res) => {
        this.setState({
          blockers: res.blockers,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  hideModal = () => {
    this.setState({
      showRelativeModal: false,
    });
  };

  selectRelative = (ele) => {
    this.setState({
      selectedRelative: ele,
    });
  };

  closeView = () => {
    dismissNativeWebViewOrNavigateHome(this.props.history, this.props.location);
  };

  render() {
    const {
      selectedRelative,
      cards,
      ongoingAppointment,
      completedAppointment,
      cancelledAppointment,
      scheduledAppointment,
      showRelativeModal,
      relatives,
      blockers,
      loading,
    } = this.state;
    const { history } = this.props;

    const ConsultationCard = (ele) => {
      if (ele.ongoing) {
        logEvent('Online Consultation Ongoing Card', {
          screenName: 'Online Home Screen',
          consultationId: ele.consultationId,
          requestId: ele.requestId,
        });
      }
      return (
        <NewOnlineConsultationCard
          key={ele.consultationId}
          order={ele}
          onlinePreview
          onTap={() => this.openOrder(ele)}
        />
      );
    };

    const TopCTA = () => {
      return (
        <>
          {cards.map((card, idx) => {
            return (
              <CTA
                className="blue-box flex-row-center-end justify-between"
                key={idx}
                style={{
                  // paddingRight: '14px',
                  borderRadius: '12px',
                }}
                onTap={() => {
                  if (blockers.cancelledRequest > 0) {
                    this.props.history.push('/consultation/cancel-blocker', {
                      requestId: blockers.cancelledRequest,
                    });
                  } else {
                    const relativeId = this.state?.relatives?.find(
                      (relative) => relative.id !== 'self'
                    )?.id;
                    this.props.history.push('/consultation/doctor-select', {
                      specialistSearch: false,
                      showVerticals: card.showVerticals,
                      searchType: 'treat',
                      relativeId,
                    });
                  }
                }}
              >
                <div>
                  <span className="text-textbox text-body-s  font-bold">
                    {card.label}
                  </span>
                  <br />
                  <span className="text-textbox text-body-s font-bold opacity-80">
                    {card.description}
                  </span>
                </div>
                <div className="h-100">
                  <svg
                    width="1"
                    height="40"
                    viewBox="0 0 1 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.5"
                      y1="2.18557e-08"
                      x2="0.499998"
                      y2="40"
                      stroke="white"
                    />
                  </svg>
                  <div className="ml-24px mr-10px">
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.749999 8.48662L3.99494 5.025L0.75 1.56337L1.74899 0.5L6 5.025L1.74899 9.55L0.749999 8.48662Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </CTA>
            );
          })}
        </>
      );
    };
    const lottieOptions = {
      loop: true,
      autoplay: true,
      animationData: onlineDoctorLottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    return (
      <FadeInTransition
        in={true}
        timeout={200}
        mountOnEnter
        unmountOnExit
        appear
      >
        <OuterContainer>
          <Header
            title={'Online Consultation'}
            onTap={() => {
              this.closeView();
            }}
            hideBackButton={clientConfig.hideTeleconsultBackButton}
          >
            <div
              className="flex justify-center items-center border border-boxCard cursor-pointer"
              style={{ borderRadius: '20px', padding: '6px 12px' }}
              onClick={() =>
                history.push('/consultation/online/my-orders', {
                  bannerImage: cards?.[0]?.bannerImage,
                })
              }
            >
              <img src={cartIcon} alt="orders" />
              <p className="ml-6px text-body-s font-semibold text-txtlight">
                My Consults
              </p>
            </div>
          </Header>
          <BodyContainer>
            {loading ? (
              <div style={{ height: '100%', background: '#ffffff' }}>
                <LoadingSkeleton />
              </div>
            ) : (
              <>
                <TopCTA />
                {ongoingAppointment.length > 0 && (
                  <div>
                    <Label className="txt-grey-500-12 mb-8 mt-8">Ongoing</Label>
                    {ongoingAppointment.map(ConsultationCard)}
                  </div>
                )}
                {scheduledAppointment.length > 0 && (
                  <div>
                    <Label className="txt-grey-500-12 mb-8 mt-8">
                      Scheduled Consultations
                    </Label>
                    {scheduledAppointment.map(ConsultationCard)}
                  </div>
                )}
                {completedAppointment.length > 0 && (
                  <div>
                    <Label className="txt-grey-500-12 mb-8 mt-8">
                      Completed
                    </Label>
                    {completedAppointment.map(ConsultationCard)}
                  </div>
                )}
                {cancelledAppointment.length > 0 && (
                  <div>
                    <Label className="txt-grey-500-12 mb-8 mt-8">
                      Cancelled
                    </Label>
                    {cancelledAppointment.map(ConsultationCard)}
                  </div>
                )}
                {(ongoingAppointment.length > 0 ||
                  scheduledAppointment.length > 0 ||
                  completedAppointment.length > 0 ||
                  cancelledAppointment.length > 0) && (
                  <div className="mt-32px">
                    <p
                      className="text-title-m font-medium text-center"
                      style={{ color: 'rgba(15, 11, 40, 0.6)' }}
                    >
                      Searching for your previous consultations?
                    </p>
                    <PrimaryButton
                      className="mt-24px mb-36px"
                      onTap={() =>
                        history.push('/consultation/online/my-orders', {
                          bannerImage: cards?.[0]?.bannerImage,
                        })
                      }
                    >
                      <ButtonText>View Past Consultations</ButtonText>
                    </PrimaryButton>
                  </div>
                )}
                {ongoingAppointment.length === 0 &&
                  completedAppointment.length === 0 &&
                  scheduledAppointment.length === 0 &&
                  cancelledAppointment.length === 0 &&
                  !loading && (
                    <div className="flex flex-col pt-32px items-center w-full h-full">
                      {clientConfig.showBannerInEmptyConsultations &&
                      cards?.[0]?.bannerImage ? (
                        <img
                          src={cards[0].bannerImage}
                          alt="Banner"
                          className="w-full object-cover"
                        />
                      ) : (
                        <Lottie
                          options={lottieOptions}
                          height={320}
                          width={300}
                        ></Lottie>
                      )}
                      {/*  */}
                      <p className=" text-title-m2 font-bold text-primary text-center mt-2">
                        Nothing to see here!
                      </p>
                      <p className="text-body-l font-semibold text-modalTextColor text-center mt-6">
                        No Consultations Booked!.
                      </p>
                      <p className="text-body-l font-semibold text-modalTextColor text-center ">
                        Want to see your previous consultations?
                      </p>
                      <div className="w-full">
                        <div className="fab-help-icon flex justify-end mb-2">
                          <FAB />
                        </div>
                        <PrimaryButton
                          className="w-full"
                          onTap={() =>
                            history.push('/consultation/online/my-orders', {
                              bannerImage: cards?.[0]?.bannerImage,
                            })
                          }
                        >
                          <div className="text-body-s text-center py-4px font-bold">
                            View Past Consultations
                          </div>
                        </PrimaryButton>
                      </div>
                    </div>
                  )}
              </>
            )}

            {showRelativeModal && (
              <RelativeSelect
                relatives={relatives}
                hideModal={this.hideModal}
                selectedRelative={selectedRelative}
                selectRelative={this.selectRelative}
              />
            )}
          </BodyContainer>
        </OuterContainer>
      </FadeInTransition>
    );
  }
}

const Label = ({ children }) => {
  return <div className="text-body-l font-semibold my-24px">{children}</div>;
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  user: state.user,
  moduleBasedLogin: state.app.moduleBasedLogin,
  magicBasedLogin: state.app.magicBasedLogin,
});

export default connect(mapStateToProps)(OnlineConsultationStartPreview);
